import { store } from '@/store';
import { HOME_SCHOOL_IDS } from '@/config/settings';

const featureToggle = {
  NotSet: 'NotSet',
  Disabled: 'Disabled',
  Enabled: 'Enabled'
};

const hasClassroomSchoolFeature = featureName => {
  try {
    const state = store.getState();

    if (state?.user?.featureFlagSchools?.length === 0) return false;

    const classroomSchoolFlags = state.user.featureFlagSchools?.filter(
      c => !HOME_SCHOOL_IDS.includes(c.schoolId)
    );

    if (classroomSchoolFlags?.length === 0) return false;

    return classroomSchoolFlags?.some(c =>
      c?.dynamicFeatures?.some(
        d =>
          d.description.toLowerCase() === featureName.toLowerCase() &&
          d.featureToggle === 'Enabled'
      )
    );
  } catch (e) {
    console.error(e);
    return false;
  }
};

const getFeature = featureName => {
  const state = store.getState();
  const schoolFeatures = state.user.featureFlagSchools;
  const foundSchool = schoolFeatures.find(ffs => ffs[featureName] !== null);
  if (!foundSchool) return featureToggle.NotSet;
  return foundSchool[featureName];
};

const getFeatureFlagSchoolIds = () => {
  const state = store.getState();
  const schoolFeatures = state.user.featureFlagSchools;
  return schoolFeatures.map(ffs => ffs.schoolId);
};

// find feature toggle for feature flag school, enabled by default
const hasFeature = featureName => {
  if (!featureName) return true;

  const state = store.getState();
  const schoolFeatures = state.user.featureFlagSchools;

  if (schoolFeatures?.length) {
    const isAnyDisabled = schoolFeatures.filter(
      ffs =>
        ffs[featureName] === featureToggle.Disabled &&
        !HOME_SCHOOL_IDS.includes(ffs.schoolId)
    );

    return !isAnyDisabled?.length;
  }

  return true;
};

const hasEnabledFeature = featureName => {
  const state = store.getState();
  const schoolFeatures = state.user.featureFlagSchools;

  if (schoolFeatures?.length) {
    return !!schoolFeatures.filter(
      ffs =>
        ffs[featureName] === featureToggle.Enabled &&
        !HOME_SCHOOL_IDS.includes(ffs.schoolId)
    )?.length;
  }

  return false;
};

const getDynamicFeatures = () => {
  try {
    const state = store.getState();
    const schoolFeatures = state.user.featureFlagSchools;

    console.log('schoolFeatures', schoolFeatures);

    if (!schoolFeatures?.length) return featureToggle.NotSet;

    return [].concat.apply(
      [],
      schoolFeatures?.map(s =>
        s.dynamicFeatures.map(d => ({ ...d, schoolId: s.schoolId }))
      )
    );
  } catch (e) {
    console.error(e);
  }
  return [];
};

const hasDynamicFeature = featureName => {
  if (!featureName) return featureToggle.NotSet;

  try {
    const dynamicFeatures = getDynamicFeatures();

    const dynamicFeature = dynamicFeatures.find(
      df => df.description === featureName
    );

    if (
      !!dynamicFeature &&
      [featureToggle.Disabled, featureToggle.Enabled].includes(
        dynamicFeature?.featureToggle
      )
    ) {
      return dynamicFeature.featureToggle;
    }
  } catch (e) {
    console.error(e);
  }

  return featureToggle.NotSet;
};

export {
  getFeature,
  hasFeature,
  hasEnabledFeature,
  hasDynamicFeature,
  featureToggle,
  hasClassroomSchoolFeature,
  getDynamicFeatures,
  getFeatureFlagSchoolIds
};
